import { render } from "./LoginForm.vue?vue&type=template&id=d4522cf8&scoped=true"
import script from "./LoginForm.vue?vue&type=script&lang=ts"
export * from "./LoginForm.vue?vue&type=script&lang=ts"

import "./LoginForm.vue?vue&type=style&index=0&id=d4522cf8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d4522cf8"

export default script